function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "GoogleBtnLogo_svg__42_b",
  x: 0,
  y: 0,
  width: 40,
  height: 40,
  rx: 2
}), React.createElement("rect", {
  id: "GoogleBtnLogo_svg__43_c",
  x: 5,
  y: 5,
  width: 38,
  height: 38,
  rx: 1
}), React.createElement("filter", {
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%",
  filterUnits: "objectBoundingBox",
  id: "GoogleBtnLogo_svg__41_a"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(3 3)",
  filter: "url(#GoogleBtnLogo_svg__41_a)"
}, React.createElement("use", {
  fill: "#4285F4",
  xlinkHref: "#GoogleBtnLogo_svg__42_b"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__42_b"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__42_b"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__42_b"
})), React.createElement("g", {
  transform: "translate(-1 -1)"
}, React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#GoogleBtnLogo_svg__43_c"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__43_c"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__43_c"
}), React.createElement("use", {
  xlinkHref: "#GoogleBtnLogo_svg__43_c"
})), React.createElement("path", {
  d: "M31.64 23.205c0-.639-.057-1.252-.164-1.841H23v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
  fill: "#4285F4"
}), React.createElement("path", {
  d: "M23 32c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711h-3.007v2.332A8.997 8.997 0 0023 32z",
  fill: "#34A853"
}), React.createElement("path", {
  d: "M17.964 24.71a5.41 5.41 0 01-.282-1.71c0-.593.102-1.17.282-1.71v-2.332h-3.007A8.996 8.996 0 0014 23c0 1.452.348 2.827.957 4.042l3.007-2.332z",
  fill: "#FBBC05"
}), React.createElement("path", {
  d: "M23 17.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C27.463 14.891 25.426 14 23 14a8.997 8.997 0 00-8.043 4.958l3.007 2.332c.708-2.127 2.692-3.71 5.036-3.71z",
  fill: "#EA4335"
}), React.createElement("path", {
  d: "M14 14h18v18H14V14z"
}));

var SvgGoogleBtnLogo = function SvgGoogleBtnLogo(props) {
  return React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46"
  }, props), _ref, _ref2);
};

export default SvgGoogleBtnLogo;